import { useState, useEffect } from "react";
import styled from "styled-components/macro";

import Teaser from "./components/Teaser";
import StockInfo from "./components/StockInfo";
import Ticker from "./components/Ticker";
import CallToAction from "./components/CallToAction";

const ChartBox = styled.div`
  display: flex;
  flex: 100% 1 0;
  flex-direction: column;
  justify-content: space-between;

  background-color: #fff;
  padding: 20px;

  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 560px) {
    padding: 40px;
  }

  @media screen and (min-width: 993px) {
    padding: 30px;
  }

  @media screen and (min-width: 1380px) {
    padding: 68px 40px 43px 40px;
  }
`;

function App() {
  const [stockData, setStockData] = useState({});
  const [lang, setLang] = useState({});

  useEffect(() => {
    async function fetchStockData() {
      const stockDataRes = await fetch(
        `https://api.eventually.cloud/api/v1/sc/teaser`
      );

      const data = await stockDataRes.json();
      setStockData(data);
    }

    fetchStockData();
  }, []);

  useEffect(() => {
    const docLang = document?.documentElement?.lang?.slice(0, 2);
    setLang(docLang);
  }, []);

  return (
    <Teaser>
      <ChartBox>
        <StockInfo lang={lang} date={stockData?.date} time={stockData?.time} />
        <Ticker
          currentPrice={stockData?.currentPrice}
          change={stockData?.change}
          percentageChange={stockData?.percentageChange}
          arrow={stockData?.arrow}
        />
        <CallToAction lang={lang} />
      </ChartBox>
    </Teaser>
  );
}

export default App;
